import { Link } from "react-router-dom";
import { FaTrash, FaMinus, FaPlus, FaShoppingBag, FaArrowRight } from "react-icons/fa";
import { useCart } from "../../hooks/useCart";
import { formatPrice } from "../../utils/formatPrice";
import styles from "./CartPage.module.css";

function CartPage() {
  const { items, totalCount, totalPrice, updateQuantity, removeItem } = useCart();

  if (items.length === 0) {
    return (
      <div className={styles.empty}>
        <FaShoppingBag className={styles.emptyIcon} />
        <h2>購物車是空的</h2>
        <p>快去挑選喜歡的商品吧！</p>
        <Link to="/products" className={styles.shopBtn}>
          立即選購 <FaArrowRight />
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>購物車（{totalCount} 件）</h1>

        <div className={styles.layout}>
          {/* Items */}
          <div className={styles.items}>
            {items.map(item => {
              const unitPrice = item.salePrice !== null ? item.salePrice : item.price;
              const subtotal = unitPrice * item.quantity;

              return (
                <div key={item.productId} className={styles.item}>
                  <Link to={`/products/${item.productId}`}>
                    <img
                      src={item.image}
                      alt={item.name}
                      className={styles.itemImg}
                    />
                  </Link>

                  <div className={styles.itemInfo}>
                    <Link to={`/products/${item.productId}`} className={styles.itemName}>
                      {item.name}
                    </Link>
                    <div className={styles.itemPriceRow}>
                      <span className={styles.itemPrice}>{formatPrice(unitPrice)}</span>
                      {item.salePrice !== null && (
                        <span className={styles.itemOriginal}>{formatPrice(item.price)}</span>
                      )}
                    </div>
                  </div>

                  <div className={styles.itemActions}>
                    <div className={styles.qtyControl}>
                      <button
                        onClick={() => updateQuantity(item.productId, item.quantity - 1)}
                        className={styles.qtyBtn}
                        aria-label="減少數量"
                      >
                        <FaMinus />
                      </button>
                      <span className={styles.qtyValue}>{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.productId, item.quantity + 1)}
                        className={styles.qtyBtn}
                        aria-label="增加數量"
                      >
                        <FaPlus />
                      </button>
                    </div>

                    <span className={styles.subtotal}>{formatPrice(subtotal)}</span>

                    <button
                      onClick={() => removeItem(item.productId)}
                      className={styles.removeBtn}
                      aria-label={`移除 ${item.name}`}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Summary */}
          <div className={styles.summary}>
            <h3 className={styles.summaryTitle}>訂單摘要</h3>

            <div className={styles.summaryRow}>
              <span>商品小計</span>
              <span>{formatPrice(totalPrice)}</span>
            </div>
            <div className={styles.summaryRow}>
              <span>運費</span>
              <span className={styles.freeShipping}>免費</span>
            </div>
            <div className={`${styles.summaryRow} ${styles.summaryTotal}`}>
              <span>合計</span>
              <span>{formatPrice(totalPrice)}</span>
            </div>

            <Link to="/checkout" className={styles.checkoutBtn}>
              前往結帳 <FaArrowRight />
            </Link>

            <Link to="/products" className={styles.continueBtn}>
              繼續購物
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartPage;
